// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTENT_UNLOCK_OVERLAY__GET_PLUS = "Aktivuj si PLUS";
export const CONTENT_UNLOCK_OVERLAY__SEE_5S_AD_OR_GET_PLUS = "Pr\u00edstup k odpovedi z\u00edska\u0161 ni\u017e\u0161ie uveden\u00fdmi sp\u00f4sobmi. Podpor n\u00e1s spusten\u00edm kr\u00e1tkej reklamy, alebo predplatn\u00fdm PLUS (Modr\u00fd kon\u00edk bez rekl\u00e1m).";
export const CONTENT_UNLOCK_OVERLAY__SHOW_ANSWER = "Uk\u00e1za\u0165 odpove\u010f";
export const CONTENT_UNLOCK_OVERLAY__WATCH_5S_AD = "Pozri si kr\u00e1tku reklamu";
export const FORUM_COMMENT_REMOVE_COMPLAINTS = "Zru\u0161 nahl\u00e1senie odpovede";
